module.exports = __webpack_public_path__ + "ff37302b9b6cedd79f73fd9af1826421.pdf";